define('home/templates/channelPromotionDiscussion',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression;

  return "<a href=\""
    + alias2(alias1((depth0 != null ? depth0.discussionRoute : depth0), depth0))
    + "\" class=\"channel-item__link\">\n<div class=\"channel-item__heading spacing-bottom-small\">\n<h2 class=\"truncate\" data-truncate-lines=\"2\">"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.thread : depth0)) != null ? stack1.clean_title : stack1), depth0))
    + "</h2>\n</div>\n<div class=\"channel-item__footer\">\n<span class=\"channel-item__count\">"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.thread : depth0)) != null ? stack1.posts : stack1), depth0))
    + "</span>\n<span class=\"channel-item__comment\">"
    + alias2(helpers.gettext.call(depth0 != null ? depth0 : {},"Comments",{"name":"gettext","hash":{},"data":data}))
    + "</span>\n</div>\n</a>\n";
},"useData":true})

});
